export const ROUTER_BASE_PATH = '/developers';
export const APPS_PATH = '/apps';
export const PRICING_PATH = '/pricing';
export const LOUDLY_APP_PATH = '/music';
export const LOGIN_PATH = `${LOUDLY_APP_PATH}/login`;
export const LOGOUT_PATH = `${LOUDLY_APP_PATH}/logout`;

export const REFRESH_TOKEN_COOKIE_KEY = 'refresh_token';
export const ACCESS_TOKEN_COOKIE_KEY = 'access_token';

export const SALES_EMAIL = 'mailto:sales@loudly.com';
export const TERMS_AND_CONDITIONS_URL =
  'https://www.loudly.com/terms-and-conditions';
export const PRIVACY_POLICY_URL =
  'https://www.iubenda.com/privacy-policy/97095809';

export const SUCCESS_SEARCH_PARAM = 'success';
export const CANCEL_SEARCH_PARAM = 'cancel';
